<template>
  <vx-card>
    <div class="mt-5">
      <form-wizard ref="wizard" color="rgba(var(--vs-primary), 1)" nextButtonText="Siguiente" backButtonText="Regresar" finishButtonText="Guardar" errorColor="rgba(var(--vs-danger), 1)" :title="null" :subtitle="null" f>
        <tab-content title="Antigua" class="mb-5" icon="feather icon-unlock" :before-change="validateStep1">
          <form data-vv-scope="step-1">
            <div class="vx-row">
              <div class="vx-col md:w-5/5 w-full mt-5">
                <vs-input type="password" label="Contraseña Antigua" v-model="contrasena_antigua" class="w-full" name="contrasena_antigua" v-validate="'required|min:6'"/>
                <span class="text-danger">{{ errors.first('step-1.contrasena_antigua') }}</span>
              </div>
            </div>
          </form>
        </tab-content>
        <tab-content title="Nueva" class="mb-5"  icon="feather icon-unlock" :before-change="validateStep2">
          <form data-vv-scope="step-2">
            <div class="vx-row">
              <div class="vx-col md:w-2/5 w-full mt-5">
                <vs-input type="password" label="Contraseña Nueva" v-model="contrasena_nueva" class="w-full mt-4" name="contrasena_nueva" v-validate="'required|min:6'" />
                <span class="text-danger">{{ errors.first('step-2.contrasena_nueva') }}</span>
              </div>
              <div class="vx-col md:w-1/5 w-full mt-5"></div>
              <div class="vx-col md:w-2/5 w-full mt-5">
                <vs-input type="password" label="Confirmar Contraseña" v-model="confirmar_contrasena" class="w-full mt-4" name="confirmar_contrasena" v-validate="'required|min:6'" />
                <span class="text-danger">{{ errors.first('step-2.confirmar_contrasena') }}</span>
              </div>
            </div>
          </form>
        </tab-content>
      </form-wizard>
    </div>
  </vx-card> 
</template>
<script>
import { FormWizard, TabContent } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import vSelect from 'vue-select';
import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);
Vue.component('v-select', vSelect);
import { Validator } from 'vee-validate';
const dict = {
  custom: {
    contrasena_antigua: {
      required: 'Este campo es requerido',
      min: 'Se requiere un minimo de 6 caracteres',
    },
    contrasena_nueva: {
      required: 'Este campo es requerido',
      min: 'Se requiere un minimo de 6 caracteres',
    },
    confirmar_contrasena: {
      required: 'Este campo es requerido',
      min: 'Se requiere un minimo de 6 caracteres',
    }
  }
}
Validator.localize('es', dict)
export default {
  data () {
    return {
      contrasena_antigua: '',
      contrasena_nueva: '',
      confirmar_contrasena: '',
    }
  },
  methods: {
    openLoading(){
      this.$vs.loading({type:'corners'});
    },
    closeLoading(){
      this.$vs.loading.close();
    },
    validateStep1 () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-1').then(result => {
          if (result) {
            this.consultar(resolve);
          }
        })
      })
    },
    validateStep2 () {
      return new Promise((resolve, reject) => {
        if(this.contrasena_nueva==this.confirmar_contrasena){
          if(this.contrasena_antigua==this.confirmar_contrasena){
            this.$vs.notify({title:'Error',text:'La contraseña antigua no puede ser la misma que la nueva, elige una contraseña diferente.',color:'danger',icon:'alert',time:5000})               
          }else{
            this.$validator.validateAll('step-2').then(result => {
              if (result) {
                const POST = {
                  contrasena_nueva: this.contrasena_nueva,
                };
                this.openLoading();
                this.$http.post('Empresas','CambiarPassword',POST,(data)=>{
                  if(data){
                    this.contrasena_antigua = '';
                    this.contrasena_nueva = '';
                    this.confirmar_contrasena = '';
                    this.$refs.wizard.reset();
                    this.$swal.fire(
                      'Contraseña',
                      'Se edito correctamente tu contraseña!',
                      'success'
                    );
                  }
                  this.closeLoading();
                });
                resolve(true)
              } else {
                resolve(false);
                reject('correct all values');
              }
            })
          }
        }else{
          this.$swal.fire(
            'Contraseña',
            'Las contaseñas no coinciden!',
            'error',
          );             
        }
      })
    },
    consultar(resolve){
      const POST = {
        password: this.contrasena_antigua,
      };
      this.$http.post('Empresas','ConsultarPassword',POST,(data)=>{
        if(data){
          resolve(true);
        }else{
          resolve(false);
          this.$vs.notify({title:'Error',text:'La contraseña antigua no coincide.',color:'danger',icon:'alert',time:5000})               
        }
       
      });
    },
  },
  components: {
    FormWizard,
    TabContent
  },                
}
</script>